// extracted by mini-css-extract-plugin
module.exports = {"remoteLottie":"RemoteLottie_remoteLottie___Rsla"};